<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar  [title]="title" [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="column">
  <h2>Pazienti globali - Utenti che non hanno effettuato l'accesso per categoria</h2>
  <div style="display: inline-block" style="padding-left: 2vw; padding-top: 1vw">
    <div class = "chart-container" >
      <canvas id = "myChartNeverLoggedTelemedicineStandard"></canvas>
    </div>
  </div>
</div>
